/** Форматирует Id для UI при orphan-значении. */
export function formatUnresolvedIdForDisplay(id: string | number | boolean | object | undefined): string {
    if (typeof id === "object" && id !== null) {
        return JSON.stringify(id);
    }
    return String(id);
}
